import React from 'react';

interface LinkIconProps {
  className?: string;
  color?: string;
  size?: number;
}

const LinkIcon: React.FC<LinkIconProps> = ({ className = '', color = '#0C0E21', size = 24 }) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      style={{ color }}
    >
      <path
        d="M14.1255 13.3995L12.4928 14.958C12.225 15.2136 11.7809 15.2136 11.5131 14.958C11.2453 14.7024 11.2453 14.2785 11.5131 14.0229L13.1458 12.4644C14.8569 10.831 14.8569 8.1753 13.1458 6.54196C11.4347 4.90862 8.65258 4.90862 6.94149 6.54196L3.67604 9.65902C1.96494 11.2924 1.96494 13.9481 3.67604 15.5814C4.39444 16.2672 5.34794 16.6911 6.36023 16.7846C6.73902 16.822 7.01985 17.1399 6.98719 17.5078C6.94801 17.8693 6.61495 18.1374 6.22963 18.1062C4.89079 17.9878 3.63685 17.4267 2.68987 16.5228C0.43671 14.372 0.43671 10.8809 2.68987 8.73013L5.95532 5.61308C8.20848 3.46231 11.8658 3.46231 14.1189 5.61308C16.3721 7.76385 16.3786 11.2487 14.1255 13.3995Z"
        fill="currentColor"
      />
      <path
        d="M21.3093 15.2699L18.0439 18.3869C15.7907 20.5377 12.1334 20.5377 9.88024 18.3869C7.62708 16.2362 7.62708 12.745 9.88024 10.5943L11.513 9.03575C11.7807 8.78015 12.2248 8.78015 12.4926 9.03575C12.7604 9.29135 12.7604 9.71527 12.4926 9.97087L10.8599 11.5294C9.14878 13.1627 9.14878 15.8185 10.8599 17.4518C12.571 19.0851 15.3531 19.0851 17.0642 17.4518L20.3297 14.3347C22.0408 12.7014 22.0408 10.0457 20.3297 8.41234C19.6113 7.72659 18.6578 7.30267 17.6455 7.20916C17.2667 7.17176 16.9859 6.85382 17.0185 6.48601C17.0512 6.11819 17.3908 5.85635 17.7761 5.88752C19.1149 6.00597 20.3689 6.56704 21.3158 7.47099C23.5625 9.62799 23.5625 13.1191 21.3093 15.2699Z"
        fill="currentColor"
      />
    </svg>
  );
};

export default LinkIcon;
